import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import RounderContainer from '@r1-frontend/ui-react/experimental/containers/RounderContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import StaticDesktopRouter from './StaticDesktopRouter';

export const StaticDesktop = styled(StaticDesktopRouter)`
    position: relative;
    display: block;
    background-color: ${COLORS.BgSurface};

    width: 304px;
    height: 354px;
    
    transition: .3s;

    :hover{
        box-shadow: rgba(0, 0, 0, 0.07) 0px 6px 12px;
    }

    & > ${IndentContainer} > ${RounderContainer} {
        background-color: ${COLORS.TextWhite};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: auto;
    }
`;

export const ImageWrapper = styled.div`
    position: relative;
    padding: 4px 0 12px 0;
    width: 100%;
    & img {
        width: auto !important;
        max-height: 112px;
        margin: auto;
    }
`;

export const DescriptionBlock = styled.div`
    height: 64px;
`;

export const LabelWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    position: absolute;
    z-index: 1;
    top: 4px;
    left: 8px;
    
    @media (min-width: ${wideBreakpoints.mobile}) {
        top: 6px;
        left: 12px;
    }
`;

export const DesktopFooter = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: flex-end;
`;

export const Block = styled.div`
    display: block;
`;
